import { initI18n } from 'www/utils'
import ScheduleLpu from 'www/modules/Schedule/classes/ScheduleLpu'

const init = async () => {
  await initI18n({ bundle: 'modules/Schedule/classes/ScheduleLpu' })

  new ScheduleLpu({
    selectorContainersSlots: '.b-card__appointment-calendar',
    selectorContainerObserver: '[data-cards-list-container]',
  })
}

init()
